import styled from 'styled-components';

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
`;

export const Popup = styled.div`
	background: #fff;
	padding: 20px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
	position: relative;
	height: 25%;
	width: 40%;
	text-align: center;
	display: flex;
	flex-direction: column;
`;

export const CloseButton = styled.div`
	position: absolute;
	top: 10px;
	right: 10px;
`;

export const ModalContent = styled.div`
	padding-top: 20px;
`;

export const EditActions = styled.div`
	width: 100%;
	display: flex;
	padding: 3%;
	justify-content: space-between;
`;
